import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useTheme, getThemeClasses } from '../context/ThemeContext';

export default function AffiliateDisclosure() {
  const { theme } = useTheme();
  const themeClasses = getThemeClasses(theme);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center space-x-1 ${themeClasses.textSecondary} hover:${themeClasses.text} transition-colors`}
      >
        <span className="text-sm">Affiliate Disclosure</span>
        {isOpen ? (
          <ChevronUp className="h-4 w-4" />
        ) : (
          <ChevronDown className="h-4 w-4" />
        )}
      </button>

      {isOpen && (
        <div className={`absolute bottom-full mb-2 p-4 ${themeClasses.dropdown} rounded-lg shadow-lg border ${themeClasses.border} w-[320px] sm:w-[480px] text-sm ${themeClasses.text} leading-relaxed`}>
          <p>
            Most of the links on this website are affiliate links, which means that I may earn a commission if you click on the link or make a purchase using the link. Importantly, using these links does not affect the price of the items you buy. Prices remain the same whether you purchase through an affiliate link or a non-affiliate link.
          </p>
          <p className="mt-3">
            By using the affiliate links, you are helping support the this website that I offer for free, and I genuinely appreciate your support. This site offers all its recommendations for free, and affiliate links allow it to continue providing valuable content to our community.
          </p>
        </div>
      )}
    </div>
  );
}